import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { aplicarActualizacionPendiente } from '../../registrarServiceWorker';

/**
 * Aplica la versión nueva de la app (si hay una pendiente) cuando el usuario pasa a otra pantalla:
 * la recarga cae en la ruta a la que acaba de ir, ya con el bundle nuevo, y nunca a mitad de un
 * formulario. No hace nada al montar ni cuando solo cambian query o hash (filtros de la misma
 * pantalla). Va dentro del router.
 */
export function AplicarActualizacionAlNavegar(): null {
  const { pathname } = useLocation();
  const rutaAnterior = useRef(pathname);

  useEffect(() => {
    if (rutaAnterior.current === pathname) return;
    rutaAnterior.current = pathname;
    aplicarActualizacionPendiente();
  }, [pathname]);

  return null;
}
